/***
 * Created on 2024/3/22
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {convertToQNAPLang} from 'common/ServiceCommon';

function NotReceiveCodeDialog(props) {
    const { t, i18n } = useTranslation();

    const onSubmit = () => {
        window.open(`${window.acc_mf.common.APP_QNAP_SERVICE_URL}/${convertToQNAPLang(i18n.language)}`, '_blank');
    }

    return (
        <ModalDialog {...props} title={t('@Did not receive a code?@')} submitText={t('@Contact us@')} submitAction={onSubmit} initDisableSubmit={false}>
            <div className="dialog-content">
                <p>{t('@Sometimes carriers and email providers may incorrectly label automated text messages as spam. We can try and resend the code, but if that doesnt work contact us using the button below.@')}</p>
                <p>{t('@We recommend to use the Authenticator app since its tied directly to your physical device and the codes are not delivered over the mobile network which is more secure and safe.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default NotReceiveCodeDialog;